import { SENSOR_DATA_LEVEL } from '@/interfaces/sensordata.interface'
import { getRequestGateway } from './api.service'

let sensorDataAborter: AbortController | null = null
/* Returning sensor data for a specific floor */
export async function getSensordata(floorId, cancelPendingRequest = false, timeout) {
  if (cancelPendingRequest && sensorDataAborter) sensorDataAborter.abort()
  sensorDataAborter = new AbortController()
  const response = await getRequestGateway<SENSOR_DATA_LEVEL>(
    `core/v1/sensors/data/levels/${floorId}/latest`,
    timeout,
    3
  )
  return response.data
}

export async function getInstallations() {
  try {
    const response = await getRequestGateway('core/v1/bumbeelabs')
    if (response) return response.data
  } catch (e) {
    console.error(e)
  }
}

export async function getAreasByInstallationId(id) {
  try {
    const response = await getRequestGateway(`core/v1/bumbeelabs/${id}`)
    if (response) return response.data
  } catch (e) {
    console.error(e)
  }
}

export async function getAreasStatsByInstallationId(
  id,
  startDate,
  endDate,
  startTime,
  endTime,
  interval
) {
  try {
    const endpoint = `core/v1/bumbeelabs/${id}/stats?startDate=${startDate}&startTime=${startTime}&endDate=${endDate}&endTime=${endTime}&interval=${interval}`
    const response = await getRequestGateway(endpoint)
    if (response) return response.data
  } catch (e) {
    console.error(e)
  }
}
